/**
 * Copyright © Veeam Software Group GmbH.
 */

import { AuthTypes } from '../enums';

import type { LangsServiceBase } from 'core/services/langs/interfaces';

export const getAuthTypes = (lang: LangsServiceBase) => [
    { id: AuthTypes.Basic, name: lang.BASIC },
    { id: AuthTypes.Modern, name: lang.MODERN },
];
